import { produce } from "immer";
import _ from "lodash";
import { mergeWithArrays } from "src/util/functions";
import {
  tAdminCompanyState,
  tAdminCompanyStateImmutable,
  tAdminSettingsAction,
  tSetCompany,
  tUpdateAddress,
  tUpdateAddresses,
  tUpdateBrandEthos,
  tUpdateBrandEthosNonToggle,
  tUpdateHeroImages,
  tUpdateSettings,
} from "./types";

const handleUpdate = (state: tAdminCompanyState, action: tUpdateSettings): tAdminCompanyState => {
  return mergeWithArrays<tAdminCompanyState>(state, "CONCAT", action.settingsPart);
};

const handleUpdateBrandEthos = (state: tAdminCompanyState, action: tUpdateBrandEthosNonToggle): tAdminCompanyState => {
  if (state.type === "brand") {
    state.brandEthos = state.brandEthos.filter((a) => a !== action.toggle);
    if (action.isBool) {
      state.brandEthos.push(action.toggle);
      return state;
    }
  }
  return state;
};
const handleUpdateBrandEthosToggle = (state: tAdminCompanyState, action: tUpdateBrandEthos): tAdminCompanyState => {
  if (state.type === "brand") {
    if (state.brandEthos.includes(action.toggle)) {
      state.brandEthos = state.brandEthos.filter((a) => a !== action.toggle);
      return state;
    }
    state.brandEthos.push(action.toggle);
    return state;
  }
  return state;
};

const handleUpdateAddress = (state: tAdminCompanyState, action: tUpdateAddress): tAdminCompanyState => {
  if (state.type === "brand" || state.type === "retailer") {
    state.addresses[0] = _.merge(state.addresses[0], action.address);
    return state;
  }
  return state;
};

const handleUpdateAddresses = (state: tAdminCompanyState, action: tUpdateAddresses): tAdminCompanyState => {
  if (state.type === "brand" || state.type === "retailer") {
    state.addresses = action.addresses || [];
    return state;
  }
  return state;
};

const handleSetCompany = (action: tSetCompany): tAdminCompanyState => {
  return action.company;
};
const handleUpdateHeroImages = (state: tAdminCompanyState, action: tUpdateHeroImages): tAdminCompanyState => {
  if (state.type === "brand") {
    state.images.heroes = action.images;
  }
  return state;
};

const handleReset = (): tAdminCompanyState => {
  return { type: "none" };
};

// Inspiration from: https://adostes.medium.com/simplify-redux-reducers-with-immer-9a3638229d45
export const AdminSettingReducer = produce(
  (draft: tAdminCompanyState = { type: "none" }, action: tAdminSettingsAction): tAdminCompanyStateImmutable => {
    switch (action.type) {
      case "ADMIN_UPDATE_CONTACT_SETTINGS":
        return handleUpdate(draft, action);
      case "ADMIN_UPDATE_BRAND_SETTINGS":
        return handleUpdate(draft, action);
      case "ADMIN_UPDATE_BRAND_ISEXCLUSIVE":
        if (draft.type === "brand") {
          draft.isExclusive = action.isExclusive;
        }
        return draft;
      case "ADMIN_UPDATE_BRAND_ETHOS_NON_TOGGLE":
        return handleUpdateBrandEthos(draft, action);
      case "ADMIN_UPDATE_REP_SETTINGS":
        return handleUpdate(draft, action);
      case "ADMIN_UPDATE_RETAIL_SETTINGS":
        return handleUpdate(draft, action);
      case "ADMIN_UPDATE_BRAND_ETHOS":
        return handleUpdateBrandEthosToggle(draft, action);
      case "ADMIN_UPDATE_ADDRESS":
        return handleUpdateAddress(draft, action);
      case "ADMIN_UPDATE_ADDRESSES":
        return handleUpdateAddresses(draft, action);
      case "ADMIN_SET_COMPANY":
        return handleSetCompany(action);
      case "ADMIN_RESET_SETTINGS":
        return handleReset();
      case "ADMIN_UPDATE_HERO_IMAGES":
        return handleUpdateHeroImages(draft, action);
      default:
        return draft;
    }
  },
);
